module.exports = __webpack_public_path__ + "img/1_seguridad.11832b57.jpg";